import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PagoService } from 'src/app/services/pago.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import * as _ from 'lodash'

@Component({
  selector: 'app-cheques-cambiar-fecha-modal-cambiar',
  templateUrl: './modal-cambiar-fecha.component.html',
  styleUrls: ['./modal-cambiar-fecha.component.scss'],
  providers: [SecurityService],
})
export class ModalCambiarFechaComponent implements OnInit {

  // Modales
  @ViewChild('cambiarFecha', { static: true }) modalCambiarFecha: ModalDirective;

  // Output
  @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>()

  // Form
  formData: FormGroup

  // data & tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  pago: any = null

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private formValidatorsService: FormValidatorsService,
    private pagoService: PagoService,
    private messageRendererService: MessageRendererService
  ) {
    this.log = this.clog.log('CHEQUES-CAMBIAR-FECHA-MODAL')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())

    this.createForm()
  }

  private createForm() {
    this.formData = this.fb.group({
      nuevaFechaVencimiento: [null, [Validators.required]],
      observacion: [null, [Validators.required, Validators.maxLength(200)]],
    });
  }

  loadAndShow(codigo, numero_doc) {
    this.pago = null
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        codigo,
        numero_doc
      }
    }
    this.log('inputParams obtenerChequeIngresadosSegunCodigo', JSON.stringify(inputParams))
    this.pagoService.obtenerChequeIngresadosSegunCodigo(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.pago = respuesta
      delete this.pago.__typename
      this.formData.get('nuevaFechaVencimiento').setValue(this.pago.fecha_vencimiento)
      this.formData.get('observacion').setValue(this.pago.observacion)
      this.modalCambiarFecha.show()
    })
  }

  hide() {
    this.formData.reset();
    this.modalCambiarFecha.hide()
  }

  cambiarFechaVencimiento() {
    const valid = this.formValidatorsService.validate(this.formData)
    if (!valid)
      return
    const inputParams = {
      entidad: _.cloneDeep(this.pago)
    }
    inputParams.entidad.fecha_vencimiento = this.formData.get('nuevaFechaVencimiento').value
    inputParams.entidad.observacion = this.formData.get('observacion').value

    this.log('guardar nueva fecha vencimiento', JSON.stringify(inputParams))

    this.pagoService.cambiarFechaVencimiento(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.toastrService.success('Operación realizada')
      this.hide()
      this.onSuccess.emit(respuesta)
    })
  }

}
